"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_OWNER = void 0;
exports.FILE_OWNER = {
    CAMPAIGN: 'CAMPAIGN',
    CUSTOMER_ACCOUNT: 'CUSTOMER_ACCOUNT',
    LANDING: 'LANDING',
    PRODUCT: 'PRODUCT'
};
//# sourceMappingURL=fileOwner.js.map